

function LinkToMessenger() {
    return (
        <>
            <div id="linktoMessenger"></div>
            <div className="bg-white shadow-md flex items-center justify-center py-10
                            2xl:px-60
                            xl:px-40
                            lg:px-20 
                            md:px-10 md:flex-row
                            flex-col
            ">
                <img src="/image/LinktoWeb.png" className="w-60" />
                <div className="flex flex-col items-center justify-center text-right
                                md:items-end">
                    <h1 className="t-purpleDark 
                                    md:text-2xl md:mb-5
                                    sm:text-xl
                                    text-lg my-4
                                    ">ورود به نسخه وب پیام رسان بوستان</h1>
                    <p className="text-slate-400 font-bold leading-9 mb-5
                                    2xl:w-9/12
                                    xl:w-8/12
                                    md:w-8/12 md:text-base md:text-right
                                    sm:w-10/12
                                    w-9/12 text-sm text-center rtol
                                    "> با ورود به نسخه وب پیام‌رسان بوستان، می‌توانید به راحتی و از هر مرورگری به پیام‌های خود دسترسی پیدا کرده، گفتگوهایتان را مدیریت کنید و تجربه‌ای سریع و امن از ارتباط آنلاین داشته باشید. </p>
                    <a href="https://web.bustan-messenger.ir"
                        className="bg-purpleDark rounded-md px-16 py-2 text-white shadow-lg"
                    >ورود به نسخه وب</a>
                </div>
            </div>
        </>
    )
}
export default LinkToMessenger;